window.__AppConfiguration = require('app-config');